import React, { Fragment, useEffect, useState } from "react";
import SlideOver from "./slideOver";
import ImageCard from "./imageCard";
import { FilterIcon, ResetIcon } from "../../../../assets/icons/index";
import { IQuestionImageFilter } from "../../../../model/interface/questionImageFilter";
import { IQuestionImage } from "../../../../model/interface/questionImage";
import { IStandard } from "../../../../model/interface/standard";
import DropDownComponent from "../metadataDropDownList";
import { getQuestionImages } from "../../../../api/question.service";
import QuestionTypeSelect from "../questionTypeSelect";
import {
  getSubjectByState,
  getStateAll,
} from "../../../../api/subject.service";
import { getAllDomainsBySubject } from "../../../../api/domain.service";
import { getStandards } from "../../../../api/standard.service";
import Loader from "../../../shared/loader/loader";
import constant from "../../../../utils/constant";

export interface ImageProperty {
  questionId: number;
  imageUrl: string;
  imageName: string;
  questionType: string;
  subject: string;
  domain: string;
  standard: string;
  usatpId: string;
  dok: string;
  author: string;
}

const ImageGallery: React.FC = () => {
  const defaultImageDetails: ImageProperty = {
    questionId: 0,
    imageUrl: "",
    imageName: "",
    questionType: "",
    subject: "",
    domain: "",
    standard: "",
    usatpId: "",
    dok: "",
    author: "",
  };
  const defaultQuestionImageData: Array<IQuestionImage> = [];

  const [states, setStates] = useState<Array<{ label: string; value: number }>>(
    []
  );
  const [gradeSubjects, setGradeSubjects] = useState<
    Array<{ label: string; value: number }>
  >([]);
  const [domains, setDomains] = useState<
    Array<{ label: string; value: number }>
  >([]);
  const [standards, setStandards] = useState<
    Array<{ label: string; value: number }>
  >([]);

  const [disableStateDDL, setDisableStateDDL] = useState<boolean>(true);
  const [disableSubjectDDL, setDisableSubjectDDL] = useState<boolean>(true);
  const [disableDomainDDL, setDisableDomainDDL] = useState<boolean>(true);
  const [disableStandardDDL, setDisableStandardDDL] = useState<boolean>(true);

  const [loading, setLoading] = useState<boolean>(false);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [showSlideOver, setShowSlideOver] = useState(false);
  const [imageDetails, setImageDetails] = useState(defaultImageDetails);
  const [selectedQuestionTypeId, setQuestionTypeId] = useState(0);
  const [selectedStateId, setStateId] = useState(0);
  const [selectedSubjectId, setSubjectId] = useState(0);
  const [selectedDomainId, setDomainId] = useState(0);
  const [selectedStandardId, setStandardId] = useState(0);
  const [selectedUSATPID, setUSATPID] = useState("");
  const [selectedDOK, setDOK] = useState(0);
  const [selectedAuthor, setAuthor] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const [questionImageData, setQuestionImageData] = useState(
    defaultQuestionImageData
  );
  const [isApproved, setisApproved] = useState<boolean>(true);
  const [isActiveSubject, setisActive] = useState<boolean>(true);

  useEffect(() => {
    bindStateData();
    if (selectedStateId) {
      bindSubjectsData();
    }

    if (selectedSubjectId) {
      bindDomainsData();
    }

    if (selectedDomainId) {
      bindStandardData();
    }
  }, [selectedStateId, selectedSubjectId, selectedDomainId]);

  const bindStateData = () => {
    async function stateReload() {
      setLoading(true);
      const response = getStateAll(100, 1);

      const data = (await response).data;
      const stateDDLData = data.data.map((values: any) => {
        return {
          label: values?.name,
          value: values?.stateId,
        };
      });
      setStates(stateDDLData);
      setLoading(false);
    }
    stateReload();
  };

  const bindSubjectsData = () => {
    async function subjectReload() {
      setLoading(true);
      const response = getSubjectByState(100, 1, selectedStateId, true, true);
      const data = (await response).data;
      const subjectDDLData = data.data.map((values: any) => {
        return {
          label: values?.name,
          value: values?.subjectId,
        };
      });
      setGradeSubjects(subjectDDLData);
      setLoading(false);
    }
    subjectReload();
  };

  const bindDomainsData = () => {
    getAllDomainsBySubject(selectedSubjectId, 100, 1).then((res) => {
      const domainDDLData = res.data.data.map((values: any) => {
        return {
          label: values?.name,
          value: values?.domainId,
        };
      });
      setDomains(domainDDLData);
    });
  };

  const bindStandardData = () => {
    const standard: IStandard = {
      name: "",
      contentAreaId: "",
      subjectId: "",
      domainId: selectedDomainId.toString(),
      code: "",
      isActive: true,
      description: "",
      loadOrder: 0,
      pageSize: 100,
      pageNumber: 1,
      orderbyColumn: "Name",
      sortDir: "ASC",
    };
    getStandards(standard).then((res: any) => {
      const domainDDLData = res.data.data.map((values: any) => {
        return {
          label: values?.name,
          value: values?.standardId,
        };
      });
      setStandards(domainDDLData);
    });
  };

  const handleShowSlideOver = (show: boolean) => {
    setShowSlideOver(show);
  };

  const handleShowImageDetails = (data: ImageProperty) => {
    setImageDetails(data);
    setShowSlideOver(true);
  };

  const handleQuestionTypeChange = (event: any) => {
    const questionTypeId = event ? event.data.questionTypeId : 0;

    setQuestionTypeId(parseInt(questionTypeId));
    if (questionTypeId) {
      setDisableStateDDL(false);
    }
  };

  const handleStateChange = (gradeId: number) => {
    setStateId(gradeId);
  };

  const handleSubjectChange = (subjectId: number) => {
    setSubjectId(subjectId);
  };

  const handleDomainChange = (domainId: number) => {
    setDomainId(domainId);
  };

  const handleStandardChange = (standardId: number) => {
    setStandardId(standardId);
  };

  const handleUSATPIDChange = (usatpId: string) => {
    setUSATPID(usatpId);
  };

  const handleDOKChange = (DOK: number) => {
    setDOK(DOK);
  };

  const handleAuthorChange = (autherText: string) => {
    setAuthor(autherText);
  };

  const handleIsActiveChange = (isActive: boolean) => {
    setIsActive(isActive);
  };

  const handleIsPublishedChange = (isPublished: boolean) => {
    setIsPublished(isPublished);
  };

  const handleResetFilter = () => {
    setResetDropdownFlag(!resetDropdownFlag);
    setQuestionTypeId(0);
    setStateId(0);
    setSubjectId(0);
    setDomainId(0);
    setStandardId(0);
    setDOK(0);
    setUSATPID("");
    setAuthor("");
    setIsActive(false);
    setIsPublished(false);
    setDisableStateDDL(true);
    setDisableSubjectDDL(true);
    setDisableDomainDDL(true);
    setDisableStandardDDL(true);
  };

  const fetchData = () => {
    setLoading(true);
    const questionImageFilter: IQuestionImageFilter = {
      questionTypeId: selectedQuestionTypeId,
      stateId: selectedStateId,
      subjectId: selectedSubjectId,
      domainId: selectedDomainId,
      standardId: selectedStandardId,
      usatpId: selectedUSATPID,
      dok: selectedDOK,
      author: selectedAuthor,
      isActive: isActive,
      isPublished: isPublished,
      pageSize: 10,
      pageNumber: 1,
    };
    getQuestionImages(questionImageFilter)
      .then((response: any) => {
        setQuestionImageData(response.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <Fragment>
      {loading && <Loader />}
      <div className="px-4 lg:px-8">
        <div className="grid grid-cols-2">
          <h1 className="text-lg font-light text-gray-900">Image Gallery</h1>
        </div>

        <div className={"pt-6 border-b pb-6"}>
          <div
            className={
              "grid sm:grid-cols-4 md:grid-cols-8  xl:grid-cols-12 gap-6 text-sm"
            }
          >
            <div className="col-span-4">
              <div
                className={
                  "self-center place-self-srt col-span-2 dark:text-white"
                }
              >
                Question Type
              </div>
              <div className="w-full mt-1">
                <QuestionTypeSelect
                  onChange={handleQuestionTypeChange}
                  value={selectedQuestionTypeId}
                ></QuestionTypeSelect>
              </div>
            </div>
            <div className="col-span-4">
              <div
                className={
                  "self-center place-self-srt col-span-2 dark:text-white"
                }
              >
                State
              </div>
              <div className={"w-full mt-1"}>
                <DropDownComponent
                  dropName={"state"}
                  dropValue={states}
                  resetDropdown={resetDropdownFlag}
                  defaultValue={"Select State"}
                  dropSelect={handleStateChange}
                  disabled={disableStateDDL}
                  enableDisableSubjects={(isDisable) => {
                    setDisableSubjectDDL(isDisable);
                  }}
                ></DropDownComponent>
              </div>
            </div>
            <div className="col-span-4">
              <div
                className={
                  "self-center place-self-srt col-span-2 dark:text-white"
                }
              >
                Subject
              </div>
              <div className={"w-full mt-1"}>
                <DropDownComponent
                  dropName={"subjectList"}
                  dropValue={gradeSubjects}
                  resetDropdown={resetDropdownFlag}
                  defaultValue={"Select Subject"}
                  dropSelect={handleSubjectChange}
                  disabled={disableSubjectDDL}
                  enableDisableDomains={(isDisable) => {
                    setDisableDomainDDL(isDisable);
                  }}
                ></DropDownComponent>
              </div>
            </div>

            <div className="col-span-4">
              <div
                className={
                  "self-center place-self-srt col-span-2 dark:text-white"
                }
              >
                Domain
              </div>
              <div className={"w-full mt-1"}>
                <DropDownComponent
                  dropName={"domain"}
                  dropValue={domains}
                  resetDropdown={resetDropdownFlag}
                  defaultValue={"Select Domain"}
                  dropSelect={handleDomainChange}
                  disabled={disableDomainDDL}
                  enableDisableStandards={(isDisable) => {
                    setDisableStandardDDL(isDisable);
                  }}
                ></DropDownComponent>
              </div>
            </div>
            <div className="col-span-4">
              <div
                className={
                  "self-center place-self-srt col-span-2 dark:text-white"
                }
              >
                Standard
              </div>
              <div className={"w-full mt-1"}>
                <DropDownComponent
                  dropName={"standard"}
                  dropValue={standards}
                  resetDropdown={resetDropdownFlag}
                  defaultValue={"Select Standard"}
                  dropSelect={handleStandardChange}
                  disabled={disableStandardDDL}
                ></DropDownComponent>
              </div>
            </div>
            <div className="col-span-4">
              <div
                className={
                  "self-center place-self-srt col-span-2 dark:text-white"
                }
              >
                USATP/EG ID
              </div>
              <div className={"w-full mt-1"}>
                <input
                  className="appearance-none border border-gray-300 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-primary-color focus:outline-none focus:shadow-outline focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white"
                  id="username"
                  type="text"
                  placeholder="USATP/EG ID"
                  autoComplete="off"
                  value={selectedUSATPID}
                  onChange={(e) => {
                    handleUSATPIDChange(e.target.value);
                  }}
                />
              </div>
            </div>

            <div className="col-span-4">
              <div
                className={
                  "self-center place-self-srt col-span-2 dark:text-white"
                }
              >
                DOK
              </div>
              <div className={"w-full mt-1"}>
                <DropDownComponent
                  dropName={"dokList"}
                  dropValue={constant.DOK}
                  resetDropdown={resetDropdownFlag}
                  defaultValue={"Select DOK"}
                  dropSelect={handleDOKChange}
                ></DropDownComponent>
              </div>
            </div>
            <div className="col-span-4">
              <div
                className={
                  "self-center place-self-srt col-span-2 dark:text-white"
                }
              >
                Author :
              </div>
              <div className={"w-full mt-1"}>
                <input
                  className="appearance-none border border-gray-300 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-primary-color focus:outline-none focus:shadow-outline focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white"
                  id="username"
                  type="text"
                  placeholder="Author"
                  value={selectedAuthor}
                  autoComplete="off"
                  onChange={(e) => {
                    handleAuthorChange(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-span-4 flex space-x-6 items-end">
              <div className={"flex item-center"}>
                <label className="flex items-center dark:text-white">
                  <input
                    id="active"
                    name="isActive"
                    type="checkbox"
                    checked={isActive}
                    onChange={() => handleIsActiveChange(!isActive)}
                    className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                  />
                  <span className="ml-2">Active</span>
                </label>
              </div>
              <div className={"flex item-center"}>
                <label className="flex items-center dark:text-white">
                  <input
                    id="active"
                    name="isActive"
                    type="checkbox"
                    checked={isPublished}
                    onChange={() => handleIsPublishedChange(!isPublished)}
                    className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                  />
                  <span className="ml-2">Published</span>
                </label>
              </div>
            </div>
          </div>
          <div className="mt-4">
            <button
              className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
              type="button"
              onClick={() => {
                fetchData();
              }}
            >
              <FilterIcon className="w-3 h-3"></FilterIcon>
              Filter
            </button>
            <button
              type="button"
              className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
              onClick={() => {
                handleResetFilter();
              }}
            >
              <ResetIcon className="w-3 h-3"></ResetIcon>
              <span>Reset Filter</span>
            </button>
          </div>
        </div>

        <div className="mt-12 mb-16">
          <div>
            <div className=" mx-auto">
              <ul
                role="list"
                className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:grid-cols-10 xl:gap-x-8"
              >
                {questionImageData &&
                  questionImageData.map((item) => (
                    <ImageCard
                      key={item.questionId}
                      questionId={item.questionId}
                      imageUrl={item.url}
                      imageName={item.questionId.toString()}
                      questionType={item.questionType}
                      subject={item.subject}
                      domain={item.domain}
                      standard={item.standard}
                      usatpId={item.usatpId}
                      dok={
                        item.dok > 0
                          ? constant.DOK.filter(
                              (dok) => dok.value === item.dok
                            )[0].label
                          : "0"
                      }
                      author={item.author}
                      showImageDetails={handleShowImageDetails}
                    />
                  ))}
              </ul>
            </div>
          </div>
        </div>
        {showSlideOver && (
          <SlideOver
            {...imageDetails}
            showSlideOver={handleShowSlideOver}
          ></SlideOver>
        )}
      </div>
    </Fragment>
  );
};

export default ImageGallery;
